import { createTheme } from '@mui/material/styles';

// Define your primary and secondary colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#bf2226',
    },
    secondary: {
      main: '#555555',
    },
    sidebar: {
      fg: '#cccccc',
      bg: '#333333',
    },
  },
  typography: {
    // You can customize the typography here
  },
  // You can add more customization options here
});

export default theme;
